import Vue from 'vue'
import InvoiceTranformer from '@/transformers/purchase/invoice'

/**
 * @author Mariela T. TL <mariela.temozihui@jbge.com.mx>
 *
 *
 * List Invoice for id
 *
 * @return {Object}
 */

const fetchOnlyInvoice = (id) =>
  Vue.$http.get(`purchase/buy_order_invoice/detail/${id}/`)
    .then(response => {
      return InvoiceTranformer.fetch(response.data)
    })
    .catch(err => { throw err })

export default fetchOnlyInvoice



// WEBPACK FOOTER //
// ./src/services/purchase/fetchOnlyInvoice.js